import React, { useEffect, useRef, useState } from 'react';
import './downlaodAppPopUp.css'
import { useDispatch } from 'react-redux';

function C2wAppRegisterInfoPopUp({ error, handleName, handleNumber, setPopUpFlag, handleSubmit, isSuccess, isValidNumber, course }) {
  const popRef = useRef(null)
  const [name, setName] = useState('')
  const [number, setNumber] = useState('');
  const dispatch = useDispatch();

  /**
 * @hook useEffect - Outside Click Handler
 * @author Vishal Lohbande
 * @description Adds an event listener on the document to detect clicks outside the popup referenced by `popRef`.
 * When a click occurs outside the popup, it sets `setPopUpFlag` to false, effectively closing the popup.
 * Cleans up the event listener on component unmount.
 * 
 * Usage:
 * Useful for closing modals, dropdowns, or popups when clicking outside their bounds.
 */
  useEffect(() => {
    function handleOutsideClick(event) {
      if (popRef && popRef.current && !popRef.current.contains(event.target)) {
        setName('')
        setNumber('')
        dispatch(setPopUpFlag(false))
        
      }
    }
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
    }
  }, [])

  return (
    <div className='C2wDownlaodAppPopUp_ctn' ref={popRef}>
      <div className='DowanLoadAppFrom_ctn' >
        <div className='DowanLoadAppFrom_ctn_heading'>
          {'Please enter details '}
        </div>
        <div className='DowanLoadAppFrom_ctn_subheading'>{'we will get back to you'}</div>
      </div>
      {/* <div className='PopUpCourseHeadingTitle'>
        <div className='PopUpCourseHeading'>{course}</div>
      </div> */}

      <div className='dowanloadPopupButton_div'>
        <input placeholder='Enter Your Name' style={{
          borderColor: error && (name?.trim() === '' || name === null) ? 'red' : null
        }}
          onChange={(e) => {
            setName(e.target.value)
            handleName(e)
          }}
        />
        <input placeholder='Enter Your Number' style={{
          borderColor: (error && number === '') || ( isValidNumber && number !== '') ? 'red' : null
        }}
          onChange={(e) => {
            setNumber(e.target.value)
            handleNumber(e)
          }}
          maxLength={10}
        />
        <button onClick={!isSuccess ? handleSubmit : null}>{isSuccess ? <div className='btnLoader'></div> : "Submit"}</button>
      </div>
    </div>
  )
}

export default C2wAppRegisterInfoPopUp